import { useAuth, useOrganization, CreateOrganization } from '@clerk/clerk-react';
import { Navigate } from 'react-router-dom';
import type { ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

export default function ProtectedRoute({ children }: Props) {
  const { isLoaded, isSignedIn } = useAuth();
  const { isLoaded: orgLoaded, organization } = useOrganization();

  if (!isLoaded || !orgLoaded) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="text-brand-cyan animate-pulse">Loading...</div>
      </div>
    );
  }

  if (!isSignedIn) {
    return <Navigate to="/sign-in" replace />;
  }

  // No active org — prompt to create one
  if (!organization) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <CreateOrganization afterCreateOrganizationUrl="/" />
      </div>
    );
  }

  return <>{children}</>;
}
